module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/bath-151be986feea92a1defbae98c911f6c6.webp";